import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { Grid, GridItem } from '../Grid';
import { BodyText } from '../Global';

const HelpFolderArticles = ({ articles }) => (
  <Grid minCol="292px">
    <GridItem>
      {
        articles.map((article, i) => {
          if (i < Math.ceil(articles.length / 2)) {
            return (
              <BodyText mt="0" mb="12px" key={article.id}>
                <Link to={`/help/articles/${article.id}`}><li><div>{article.title}</div></li></Link>
              </BodyText>
            );
          }
          return true;
        })
      }
    </GridItem>
    <GridItem>
      {
        articles.map((article, i) => {
          if (i > Math.ceil(articles.length / 2) - 1) {
            return (
              <BodyText mt="0" mb="12px" key={article.id}>
                <Link to={`/help/articles/${article.id}`}><li><div>{article.title}</div></li></Link>
              </BodyText>
            );
          }
          return true;
        })
      }
    </GridItem>
  </Grid>
);

HelpFolderArticles.propTypes = {
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      folder_id: PropTypes.number,
      title: PropTypes.string,
    }).isRequired,
  ).isRequired,
};

export default HelpFolderArticles;
